import React, { PureComponent } from "react";
import NoData from "../NoData/NoData";
import VolumeOfNewsChart from "./VolumeofNewsChart";
import moment from "moment-timezone";
import { getViewConversationDuration, downloadCSVData, downloadCanvasWithTitle } from "../utils";
import IntervalSelector from "../IntervalSelector";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import html2canvas from "html2canvas";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";

import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

class VolumeOfNews extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.chartEl = React.createRef();
    }

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "volumeOfNews");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        // console.log(this.props.appliedFilter);
        if (d.originalX) {
            d.x = d.originalX;
        }
        d.series.name = JSON.parse(JSON.stringify(d.series.name.replace("comparisionData", ""))).trim();

        if (d.series.name !== "Total") newFilter.extras = [{ key: "Source Type", value: d.series.name.toLowerCase() }];
        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("55");

        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData.data,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );
        // newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        return newFilter;
    }

    handleContextMenuClick = (d) => {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    isHourly(data) {
        if (data.xs.length < 2) return false;
        return data.xs[1] - data.xs[0] < 24 * 59 * 60 * 1000;
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.props.data;
        let formatString = "YYYY-MM-DD HH:mm";
        let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        let csvFmt = [["Time"], ["Online"], ["Offline"], ["Total"]];

        if (this.props.comparisionData) {
            csvFmt = [...csvFmt, ...[["Comparison Time"], ["Comparison Online"], ["Comparison Offline"], ["Comparison Total"]]];
        }

        data.xs.forEach((d) => csvFmt[0].push(moment(d).tz(userTz).format(formatString)));
        if (this.props.comparisionData) {
            this.props.comparisionData.xs.forEach((d) => csvFmt[4].push(moment(d).tz(userTz).format(formatString)));
        }

        Object.keys(data.data).forEach((d, i) => {
            //csvFmt[i + 1][0] = d;

            delete data.data["date"];

            data.data[d]?.forEach((x) => {
                csvFmt[i + 1].push(x.y);
            });
        });

        if (this.props.comparisionData) {
            Object.keys(this.props.comparisionData.data).forEach((d, i) => {
                //csvFmt[i + 1][0] = d;
                delete this.props.comparisionData.data["date"];
                this.props.comparisionData.data[d]?.forEach((x) => {
                    csvFmt[i + 5].push(x.y);
                });
            });
        }

        let firstIndLen = csvFmt[0].length;
        let lastIndLen = csvFmt[csvFmt.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < csvFmt.length; j++) {
                if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                else arr[i].push(0);
            }
        }

        downloadCSVData(arr, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        // this.setState({ downloading: true });
        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            // this.setState({ downloading: false });
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton = (nodata) => {
        // return (
        //     <Dropdown
        //         disabled={nodata}
        //         trigger={
        //             <div className="chart-header-icon">
        //                 <DownloadIcon className="chart-download-icon" />
        //             </div>
        //         }
        //         icon={null}
        //         className="chart-download-dropdown hideable"
        //         direction="left">
        //         <Dropdown.Menu>
        //             <Dropdown.Item onClick={this.downloadCSV}>CSV</Dropdown.Item>
        //             <Dropdown.Item onClick={this.downloadPNG}>PNG</Dropdown.Item>
        //         </Dropdown.Menu>
        //     </Dropdown>
        // );

        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;
        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="Shows the volume of conversation from news sources over-time." />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />}
                        {!nodata && <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />}
                        {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    {/* <div className="clone-chart menu-option" onClick={this.props.chartComparision}>
                                    <span>Chart Comparision</span>
                                    <CloneIcon />
                                </div> */}
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <VolumeOfNewsChart
                            data={this.props.data}
                            addContextMenuListener={this.addContextMenuListener}
                            showGridLines={this.props.showGridLines}
                            showLegend={this.props.showLegend}
                            // resizedCount={this.props.resizedCount}
                            showLabel={this.props.showLabel}
                            comparisionData={this.props.comparisionData}
                            widgetContainerRef={this.props.widgetContainerRef}
                            legendClick={this.props.legendClick}
                            expandWidget={this.props.expandWidget}
                        />
                        {/* {this.state.downloading && <DimmerComponent />} */}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // data: state.csApiReducer.topInfluencers,
        //allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VolumeOfNews);
